import {useMediaQuery} from "@mui/material"

export default function useIsMobile():boolean {
    const isMobile = useMediaQuery((theme : any) => theme.breakpoints.down("lg"));
    return isMobile;
}


